import React from 'react';
import {
  // eslint-disable-next-line no-restricted-imports
  Text as RNText,
  TextProps as RNTextProps,
  TextStyle,
  StyleProp,
  GestureResponderEvent,
} from 'react-native';
import { IS_ANDROID } from '@/utils/platform';

import { styles } from './styles';

interface TextProps extends RNTextProps {
  style?: StyleProp<TextStyle>;
  ref?: React.ForwardedRef<RNText>;
  children: React.ReactNode;
  onPress?: (event: GestureResponderEvent) => void;
}

export const Text: React.FC<TextProps> = ({
  style,
  ref,
  children,
  onPress,
  ...rest
}) => {
  return (
    <RNText
      onPress={onPress}
      style={[styles.defaultText, style]}
      ref={ref}
      {...rest}
    >
      {children}
      {IS_ANDROID ? ' ' : null}
    </RNText>
  );
};
